import React, { useEffect, useRef, InputHTMLAttributes, useState } from 'react';
import { useField } from '@unform/core';
import { Container } from './styles';


interface Props extends InputHTMLAttributes<HTMLInputElement> {
  style?: Record<string, any>;
  name: string;
  unique?: boolean;
  preText?: JSX.Element;
  posText?: JSX.Element;
  background_line?: string;
  setCallBack?: Function;
  options: {
    id?: string;
    value: string;
    label: string;
    sub_title?: string;
  }[];
}
const CheckboxInput: React.FC<Props> = ({
  name,
  options,
  preText = '',
  posText = '',
  unique = false,
  style,
  background_line = '',
  setCallBack = (value) => { },
  ...rest
}) => {
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = [] } = useField(name);

  const [value, setValue] = useState<Array<string>>(typeof defaultValue === 'string' ? [defaultValue] : defaultValue || []);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs: HTMLInputElement[]) => {
        return value
      },

      setValue: (refs: HTMLInputElement[], values: string[] | string) => {
        setValue(typeof values === 'string' ? [values] : values);
      },
    });
  }, [defaultValue, fieldName, registerField, value]);
  return (
    <Container style={style} {...rest}>
      {preText && <label style={{ border: '0', textAlign: 'justify', color: '#333' }}>{preText}</label>}
      {options.map((option, index) => (
        <label
          onClick={(e) => {
            if (unique) {
              setValue([option.value])

              setCallBack(option.value);


            }
            else {

              const index = value?.findIndex(i => i === option.value);
              if (index >= 0) {
                setValue(value.filter(a => a !== option.value))
              }
              else {
                setValue([...value, option.value])
              }



            }
          }}

          style={{ cursor: 'pointer', color: '#333', width: '100%', background: background_line ? background_line : 'none', padding: "0px" }} htmlFor={`${name}_${option.id}`} key={`${name}_${option.id}`}>
          <input style={{ color: '#333', border: '1px solid#333' }}



            value={option.value}
            checked={value?.findIndex(i => i === option?.value) >= 0}
            type="checkbox"
            id={`${name}_${option.value}`}

          />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', marginLeft: '10px' }}>
            <strong style={{ color: '#333', fontSize: '14px' }}>{option.label}</strong>
            {option.sub_title && <p style={{ color: '#333', fontSize: '12px' }}>{option.sub_title}</p>}
          </div>
        </label>
      ))}
      {posText && <label style={{ border: '0', textAlign: 'justify', color: '#333' }}>{posText}</label>}
    </Container>
  );
};
export default CheckboxInput;
